import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/galleryApi";

export function PresetPanel({ presets, setPresets, adj, onApply }) {
  const [name, setName] = useState("");
  const save = async () => {
    try {
      const p = await api.post("/photo-studio/presets", { name: name.trim(), adjustments: adj });
      setPresets((prev) => [...prev, p]);
      setName("");
      toast.success(`Preset « ${p.name} » enregistre`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (p) => {
    await api.del(`/photo-studio/presets/${p.id}`);
    setPresets((prev) => prev.filter((x) => x.id !== p.id));
  };
  return (
    <div data-testid="preset-panel">
      <h4 className="text-[10px] uppercase tracking-[0.2em] text-[#64748B] font-semibold mb-3">Preréglages</h4>
      <div className="grid grid-cols-2 gap-1.5">
        {presets.map((p) => (
          <div key={p.id} className="group relative">
            <button onClick={() => onApply(p)} data-testid={`preset-${p.id}`}
              className="w-full text-left text-[11px] leading-tight px-2.5 py-2 rounded-md bg-[#060B14] border border-[#1A2332] hover:border-[#F97316] text-[#94A3B8] hover:text-white transition-colors">
              {p.is_builtin && <span className="block text-[8px] text-[#F97316] font-bold tracking-widest mb-0.5">PRO</span>}
              {p.name}
            </button>
            {!p.is_builtin && (
              <button onClick={() => remove(p)} className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 text-[#64748B] hover:text-red-400" data-testid={`delete-preset-${p.id}`}><Trash2 className="w-3 h-3" /></button>
            )}
          </div>
        ))}
      </div>
      <div className="flex gap-1.5 mt-3">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Enregistrer les reglages actuels…" className="h-8 text-xs bg-[#060B14] border-[#1A2332] text-white"
          onKeyDown={(e) => e.key === "Enter" && name.trim() && save()} data-testid="new-preset-name" />
        <Button size="sm" onClick={save} disabled={!name.trim()} className="h-8 px-2.5 bg-[#F97316] hover:bg-[#EA580C] text-white" data-testid="save-preset-btn"><Plus className="w-3.5 h-3.5" /></Button>
      </div>
    </div>
  );
}
